// Environment configuration
export const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  debug: process.env.REACT_APP_DEBUG === 'true',
  version: process.env.REACT_APP_VERSION || '1.0.0',
  analyticsId: process.env.REACT_APP_ANALYTICS_ID,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
} as const;

export const isDevelopment = config.environment === 'development';
export const isProduction = config.environment === 'production';
export const isStaging = config.environment === 'staging';

// Log configuration in development
if (isDevelopment && config.debug) {
  console.log('[CONFIG] Environment Configuration:', {
    apiUrl: config.apiUrl,
    environment: config.environment,
    debug: config.debug,
    version: config.version,
    analyticsId: config.analyticsId ? '***' : 'not set',
    sentryDsn: config.sentryDsn ? '***' : 'not set',
  });
}
